import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@core-engine/config/types.js'
import { ensureDir, safeWriteFile } from '@core-engine/utils/fs.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace.js'
import { applyNextCacheApiForVersion, readTemplate } from '@next-adapter/template-reader.js'

export interface ApiRoutesScaffoldOptions {
  cwd: string
  config: ResolvedBetterstartConfig
}

/**
 * Create Admin API routes under /api/admin/.
 */
export function scaffoldApiRoutes({ cwd, config }: ApiRoutesScaffoldOptions): string[] {
  const created: string[] = []
  const apiDir = path.resolve(cwd, config.paths.api)
  const namespace = config.frameworkConfig.next.namespace

  function write(relPath: string, content: string): void {
    const fullPath = path.join(apiDir, relPath)
    ensureDir(path.dirname(fullPath))
    const versionedContent = applyNextCacheApiForVersion(content, config.nextMajorVersion)
    if (safeWriteFile(fullPath, applyAdminNamespaceToContent(versionedContent, namespace))) {
      created.push(path.join(config.paths.api, relPath))
    }
  }

  // Better Auth catch-all: /api/admin/auth/[...all]/route.ts
  write(path.join('auth', '[...all]', 'route.ts'), readTemplate('api/auth-route.ts'))

  // Upload: /api/admin/upload/route.ts
  write(path.join('upload', 'route.ts'), readTemplate('api/upload-route.ts'))

  // Public stable media URL that redirects providers with signed reads.
  write(path.join('storage', '[key]', 'route.ts'), readTemplate('api/storage-read-route.ts'))

  return created
}
